import { Component, OnInit } from '@angular/core';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ObjectMetadataRefreshHistoryPopupComponent } from '../objectMetadataRefresh-history-popup/objectMetadataRefresh-history-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { JeevObjectsPopupComponent } from './jeev-objects-popup/jeev-objects-popup.component';

@Component({
    selector: 'app-jeev-objects',
    templateUrl: './jeev-objects.component.html',
    styleUrls: ['./jeev-objects.component.scss'],
    standalone: false
})

/* Author- Renuka chama
  16/03/2026
  For creation of  JSuite object screen */

export class JeevObjectsComponent implements OnInit {


  gridApi
  gridColumnAPI
  lastpage: any;
  currentpage: any;
  nextpage: any;
  totalpages: any;
  nextpageplusone: any;
  pagesize
  paginationPageSize
  paginationNumberFormatter
  buttonColor
  backgroundColorScreen
  getRowStyle: (params: any) => { backgroundColor: string; };
  components

  rowClassRules
  defaultColDef
  columnDefs
  tableName: string;
  dnsId: string;
  buttonIdList = []
  getdata: null;
  buttonName: any;

  constructor(private spinner: NgxUiLoaderService, private dialog: MatDialog, private localStorrageSettings: LocalStorageSettingsService, private commonService: CommonService, private snackbar: MatSnackBar) {
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  ngOnInit(): void {
    this.tableName = 'jsuiteobjects'
    this.dnsId = this.localStorrageSettings.getSettings("dnsName")

    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' };
      }
    };

    this.buttonColor = this.localStorrageSettings.getSettings("ColorA")
    this.backgroundColorScreen = this.localStorrageSettings.getSettings("ColorD")

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.paginationPageSize = 10;
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        pinned: 'left',
        lockPinned: true,
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          refreshObject: this.refreshObject.bind(this),
          showRefresh: true
        },
        width: 180
      },

      {
        headerName: 'Object Id',
        headerTooltip: 'Object Id',
        tooltipValueGetter: params => 'Object Id : ' + params.value,
        field: 'objectId',
        filter: 'agTextColumnFilter',
        width: 100
      },

      {
        headerName: 'Object Name',
        headerTooltip: 'Object Name',
        tooltipValueGetter: params => 'Object Name : ' + params.value,
        field: 'objectName',
        filter: 'agTextColumnFilter',
        width: 150
      },

      {
        headerName: 'Object Type',
        headerTooltip: 'Object Type',
        tooltipValueGetter: params => 'Object Type : ' + params.value,
        field: 'objectTypeName',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Attributes',
        headerTooltip: 'Attributes',
        tooltipValueGetter: params => 'Attributes : ' + params.value,
        field: 'attributes',
        filter: 'agTextColumnFilter',
        width: 150
      },
      {
        headerName: 'Lifecycle',
        headerTooltip: 'Lifecycle',
        tooltipValueGetter: params => 'Lifecycle : ' + params.value,
        field: 'lifecycleName',
        filter: 'agTextColumnFilter',
        width: 150
      }
    ]
  }



  onGridReady(params) {
    this.gridApi = params;
    this.gridColumnAPI = params.columnApi;
    params.api.setGridOption('rowData', []);
    this.retrieveObjects();
  }

  refreshRun() {
    this.spinner.start();
    this.onGridReady(this.gridApi);
    this.spinner.stop();
  }

  retrieveObjects() {

    this.spinner.start();

    this.commonService.getAllJeevObjects().subscribe({

      next: (response: any) => {

        console.log("Grid Data:", response);

        if (response && response.length > 0) {
          this.gridApi.api.setGridOption('rowData', response);
        } else {
          this.gridApi.api.setGridOption('rowData', []);
        }

        this.spinner.stop();
      },

      error: (err) => {
        console.error(err);
        this.spinner.stop();
        this.snackbar.open("Failed to load objects", "OK", { duration: 5000 });
      }

    });
  }


  refreshObject(event) {

    console.log("Refreshing record:", event.rowData);

    if (confirm("Are you sure you want to refresh attribute?")) {

      this.spinner.start();

      this.commonService.refreshSingleJeevObject(event.rowData.objectName)
        .subscribe((res: any) => {

          this.spinner.stop();

          if (res.error) {
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          }
          else {
            this.snackbar.open("Object refreshed successfully", "OK", { duration: 5000 });

            this.retrieveObjects(); // reload grid
          }

        }, err => {
          this.spinner.stop();
          this.snackbar.open("Refresh failed", "OK", { duration: 5000 });
        });

    }

  }
  //pagination code
  onPaginationChanged() {
    if (this.gridApi.api) {
      this.lastpage = this.gridApi.api.paginationIsLastPageFound();
      this.currentpage = this.gridApi.api.paginationGetCurrentPage() + 1
      this.nextpage = this.gridApi.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.gridApi.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.gridApi.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {

    this.gridApi.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged() {
    var value = this.pagesize
    this.gridApi.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridApi.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridApi.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.gridApi.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.gridApi.api.paginationGoToLastPage();
  }



  async startJeevObjectChangesDetection() {

    let status = "";

    const response: any = await new Promise(resolve => {
      this.commonService.getJeevObjectRefreshStatus().subscribe(resolve);
    });

    if (response !== null) {
      status = response.status;
    }

    if (status === "Completed" || status === "Failed" || status === null) {

      if (confirm("Are you sure you want to refresh all objects?")) {

        this.snackbar.open("Refresh Initiated", "OK", { duration: 5000 });

        this.commonService.refreshAllJeevObjects().subscribe((res: any) => {

          if (res.error) {
            this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
          }

        });

      }

    }
    else {

      this.snackbar.open(
        "Please wait untill last Refresh Complete.",
        "OK",
        { duration: 5000 }
      );

    }

  }

  openRefreshHistory(buttonName) {

    let width = "90%";

    const dialogRef = this.dialog.open(ObjectMetadataRefreshHistoryPopupComponent, {
      maxWidth: '100vw',
      height: "80%",
      width: width,
      data: {
        tableName: this.tableName,
        buttonName: buttonName,
        headerNameHtml: buttonName,
        dnsId: this.dnsId,
        type: 'jeevobjects'
      }
    });

  }

  openSaveForm(buttonName) {
    this.buttonName = buttonName;

    let dialogRef = this.dialog.open(JeevObjectsPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: "60%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
      data: { editData: null },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      // Only refresh if save was successful (result is truthy)
      if (result) {
        // Call retrieve() directly, NOT onGridReady()
        this.retrieveObjects();
      }
    });
  }


  editIcon(e) {
    let rowData = e.rowData;
    console.log("Edit clicked:", rowData);

    if (rowData.status === "No") {
      this.snackbar.open("Selected record is already deleted", "OK", { duration: 5000 });
      return;
    }

    let dialogRef = this.dialog.open(JeevObjectsPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: "60%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "85%",
      disableClose: true,
      data: { editData: rowData },   // send existing data to popup
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.retrieveObjects();   // refresh grid
      }
    });
  }


  deleteIcon(event) {
    console.log("Delete clicked:", event);

    if (event.rowData.status === "No") {
      this.snackbar.open("Selected record is already deleted", "OK", { duration: 5000 });
      return;
    }

    if (confirm("Are you sure you want to delete this record?")) {
      this.spinner.start();

      this.commonService.deleteJeevObject(event.rowData.objectId)
        .subscribe(result => {
          console.log(result);

          if (String(result.statusMessage) === "Successfully record is deleted") {
            this.snackbar.open("Successfully record is deleted", "OK", { duration: 5000 });
          } else {
            this.snackbar.open("Cannot delete selected record", "OK", { duration: 5000 });
          }

          this.retrieveObjects();  // refresh grid
          this.spinner.stop();
        });
    }
  }


}
